<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            Contact already in use by a Trial Account
        </template>

        <template #content>
            <div>
                One or more contacts you're trying to message are already being used by another active trial account.
            </div>
            <div class="mb-2 mt-2">
            
                To prevent spam, trial accounts cannot message contacts that are already being messaged by other trial accounts. <br /><br />

                This restriction is automatically lifted when you upgrade to a paid plan. <br /><br />
            
                Once you upgrade we'll get you registered with carriers so you can send messages to all your contacts. <br /><br />
            </div>
        </template>

        <template #footer>
            <a href='#' class="whitespace-nowrap mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" 
                v-on:click="$emit('close')" 
            >
                Okay, Got It
            </a>
    
            <Link :href="route('subscriptions.index')" @click="$emit('close')" class="">
                <jet-button secondary class="">
                    VIEW PLANS & UPGRADE
                </jet-button>
            </Link>

        </template>
    </jet-dialog-modal>

</template>


<script>
export default {
    name: 'ContactInUseOnTrialModal',
    emits: ['close'],
}
</script>